var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emojiContainer"},[_c('figure',{staticClass:"emojiWrapper"},[_c('img',{attrs:{"src":_vm.emoji(_vm.name),"alt":_vm.name}})]),_c('span',{staticClass:"percentValue"},[_vm._v(_vm._s(_vm.percentValue)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }